/**
 * 流动连线（P1 C-2b 视觉，2026-10-01）：
 *  - 常态：细灰白线（无动画）；
 *  - 选中该连线、或选中其两端节点时：线变蓝，一段发光体沿曲线从源端缓慢流向目标端；
 *  - 取消选中恢复常态。
 * 发光体用"沿路径的描边虚线段"实现（dasharray 单段 + dashoffset 动画）——因为它就是路径
 * 自身的描边，天然贴合贝塞尔曲线（不像 animateMotion 的刚性图形会在弯线上戳到线外）。
 * 圆头 + drop-shadow 光晕 + 较长段 = 彗星观感。active 由编辑器经 data.active 传入。
 */
import { getBezierPath } from '@xyflow/react';
import type { EdgeProps } from '@xyflow/react';

export function FlowEdge({
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  interactionWidth = 24,
  selected,
  data,
}: EdgeProps) {
  const [path] = getBezierPath({ sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition });
  const active = Boolean((data as { active?: boolean } | undefined)?.active) || Boolean(selected);
  return (
    <>
      <path className={`canvas-edge-base${active ? ' is-active' : ''}`} d={path} fill="none" />
      {active && <path className="canvas-edge-flow" d={path} fill="none" pathLength={100} />}
      <path
        className="canvas-edge-interaction"
        d={path}
        fill="none"
        strokeWidth={interactionWidth}
        stroke="transparent"
      />
    </>
  );
}
